//#region Libraries
//#endregion
//#region Styles
//#endregion
//#region Components
import { ContainerParts } from "components/styles";
import LocationPartForm from "views/components/LocationPartForm/LocationPartForm";
import PublicPartForm from "views/components/PublicPartForm/PublicPartForm";
//#endregion

const Step2 = ({
    dataRelatedToForm: {
        locations,
        allCampusDetail, allCampus,
        modalities
    }, form, errors, 
    changeForm 
}) => {
    const changeFieldPart1 = (field, value, errorValue) => {
        changeForm("part1", field, value, errorValue);
    }
    const changeFieldPart2 = (field, value, errorValue) => {
        changeForm("part2", field, value, errorValue);
    }
    return (
        <ContainerParts>
            <LocationPartForm
                form={form.part1}
                changeField={changeFieldPart1}
                errors={errors.part1}
                locations={locations}
                allCampus={allCampusDetail}
                as="asesoría"
                onlyInCampus />
            <PublicPartForm 
                form={form.part2}
                changeField={changeFieldPart2}
                errors={errors.part2}
                allCampus={allCampus}
                modalities={modalities}
                as="asesoría"/>
        </ContainerParts>
    );
}

export default Step2;